import { render } from "./ReelSceneEditor.vue?vue&type=template&id=27473ab6&scoped=true&ts=true"
import script from "./ReelSceneEditor.vue?vue&type=script&lang=ts"
export * from "./ReelSceneEditor.vue?vue&type=script&lang=ts"

import "./ReelSceneEditor.vue?vue&type=style&index=0&id=27473ab6&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27473ab6"]])

export default __exports__